<template>
  <div class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>证书查询</span>
          <router-link to="/home">
            <el-button size="small" type="primary">返回</el-button>        
          </router-link>
      </div>
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="certificateNo"
          :rules="certificateNoRules"
          ref="certificateNo"
          @submit.native.prevent
        >
          <el-form-item label="名称" prop="userName">
            <el-input v-model="certificateNo.userName" placeholder="请输入证书名称（证书上的姓名拼音）"></el-input>
          </el-form-item>
          <el-form-item label="编号" prop="val">
            <el-input v-model="certificateNo.val" @keyup.enter.native="getCertificate" placeholder="请输入证书编号"></el-input>
            <el-button size="small" type="primary" class="large-bt" @click="getCertificate" style="margin-top: 4px;">查询</el-button>
          </el-form-item>
        </el-form>
        <ul>
          <li>1、在该页面可以查询到的证书有：CCSK、CZTP、CDSP、CBP、CDPO、C-CCSK、CAISP、CAIDCP；</li>
          <li>2、输入名称（证书上的姓名拼音）和证书编号（如: CCSK-666666），查询到证书的相关信息；</li>
          <li>3、如有其他问题，请联系CSA大中华区工作人员0755-86548359。</li>
        </ul>
    </el-card>
    <el-dialog title="查询结果" :visible.sync="centerDialogVisible" width="50%" center>
      <div style="min-height:280px;">
        <p class="loading" v-if="loading">
          <i class="el-icon-loading"></i>
        </p>
        <img
          :style="{width:'100%', height: (loading||noCertificateImage)?'0':'auto'}"
          :src="certificateImageUrl"
          @load="certificateImageLoad"
          @error="certificateImageError"
        >
        <p style="text-align: center;" v-if="noCertificateImage">没有相关证书信息</p>
      </div>
      <!-- <el-form label-position="left" label-width="80px">
                <el-row>
                    <el-col :span="6"><el-form-item label-width="300px" label="姓名:"/></el-col>
                    <el-col :span="12"><el-form-item :label=certificateReg.chName label-width="300px" /></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><el-form-item label-width="300px" label="姓名拼音:"/></el-col>
                    <el-col :span="12"><el-form-item :label=certificateReg.enName label-width="300px" /></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><el-form-item label-width="300px" label="证书编号:"/></el-col>
                    <el-col :span="12"><el-form-item :label=certificateReg.certificateNo label-width="300px" /></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><el-form-item label-width="300px" label="颁发日期:"/></el-col>
                    <el-col :span="12"><el-form-item :label=certificateReg.createTime label-width="300px" /></el-col>
                </el-row>
                <el-row>
                    <el-col :span="6"><el-form-item label-width="300px" label="失效日期:"/></el-col>
                    <el-col :span="12"><el-form-item :label=certificateReg.expireTime label-width="300px" /></el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
      loading: false,
      noCertificateImage: false,
      certificateImageUrl: "",
      labelPosition: "right",
      certificateNo: {
        userName:"",
        val: "",
      },
      certificateNoRules: {
        userName: [{ required: true, message: "请输入证书名称（证书上的姓名拼音）", trigger: ["blur"] }],
        val: [{ required: true, message: "请输入证书编号", trigger: ["blur"] }]
      }
    };
  },
  methods: {
    getCertificate: function() {
      this.loading = true;
      this.noCertificateImage = false;
      this.certificateImageUrl = "";
      this.$refs["certificateNo"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "查询中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          this.$axios
            .get("/openApi/getCertificateByNo", {
              params: { certificateNo: this.certificateNo.val, userName: this.certificateNo.userName }
            })
            .then(res => {
              //关闭查询遮罩，打开弹窗框
              loading.close();
              this.centerDialogVisible = true;

              if (res.code == 501) {
                //没有相关证书信息，直接显示
                this.loading = false;
                this.noCertificateImage = true;
              } else {
                //有相关证书，加载
                this.loading = true;
                this.noCertificateImage = false;
                this.certificateImageUrl =
                    `/api/openApi/showCertificateByNo?time=${new Date().getTime()}&certificateNo=${this.certificateNo.val}&userName=${this.certificateNo.userName}`;
              }
            })
            .catch(err => {})
            .finally(() => {
              loading.close();
            });
        }
      });
    },
    certificateImageError: function() {
      this.loading = false;
      this.noCertificateImage = true;
    },
    certificateImageLoad: function() {
      this.loading = false;
    }
  },
  mounted() {}
};
</script>


<style scoped>
ul li {
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 8px;
  margin-top: 10px;
}
.content{
    width: 80%;
    max-width: 600px;
    margin: auto;
}
.large-bt {
  /* width: 100%; */
  /* font-size: 16px; */
  /* background: #00549f; */
}
.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 960px;
}
.box-card {
  width: 100%;
  margin-top: 10px;
}
span {
  padding-left: 16px;
  font-size: 14px;
  color: #333;
}
.el-input {
  width: 80%;
}
button {
  float: right;
  margin-left: 20px;
}
@media screen and (max-width: 767px) {
  .el-card {
    box-shadow: none;
    border: none;
  }
}
</style>
